module.exports = __webpack_public_path__ + "img/option3-active.c7af0cc0.webp";